import { Component, OnInit } from "@angular/core";
import { Store } from '@ngrx/store';
import { addSelectedFilter, removeAllFilters, removeSelectedFilter, setResultsCount } from 'src/app/actions';
import { FilterComparisonOperator, FilterGroupLogicaOperator, FilterKey, FilterLogicaOperator, FilterType, Material } from 'src/app/models';
import { materialesSelector } from 'src/app/selectors';


@Component({
  selector: 'default',
  template: '<mosaic-simple (onSelectMaterial)="addMaterialFilter($event)" [materiales]="materiales"></mosaic-simple>'
})
export class DefaultContainer implements OnInit {

  materiales: Material[] = [];

  constructor(private store: Store) {}

  addMaterialFilter(material: Material): void {
    this.store.dispatch(addSelectedFilter({ filter: {
      type: FilterType.CHECK_BOX,
      key: FilterKey.MATERIAL,
      name: material.NOMBRE,
      value: material.CODIGO,
      groupLogicalOperator: FilterGroupLogicaOperator.OR,
      logicalOperator: FilterLogicaOperator.AND,
      comparator: FilterComparisonOperator.EQUAL
    }}))
  }

  ngOnInit(): void {
    this.store.select(materialesSelector).subscribe(materiales => this.materiales = materiales);
    this.store.dispatch(setResultsCount({ count: 0 }));
    this.store.dispatch(removeAllFilters())
  }
}
